import axios, { AxiosRequestConfig } from 'axios';
import { toast } from 'react-toastify';

export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
    displayErrorMsg?: boolean;
}

export function setup(config = {}) {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    axios.defaults.headers.common.Accept = 'application/json';

    axios.interceptors.request.use(async (r) => {
        const token = localStorage.getItem('token') || '';
        if (token) {
            r.headers.authorization = `Bearer ${token}`;
        }
        return r;
    });

    axios.interceptors.response.use(
        (r) => {
            if (r?.status === 200 || r?.status === 201) {
                return r.data;
            }
            return r;
        },
        (err) => {
            const displayErrorMsg = err.config?.displayErrorMsg ?? true;

            const r = err.response;

            if (r?.status === 400 && r?.data?.message === 'You must change your password') {
                window.location.href = '/mdp-update';
            }

            if (r?.status >= 400 && r?.status < 500 && displayErrorMsg) {
                if (r?.status === 403) {
                    return;
                }
                const msg = (r.data || {}).detail || 'Vérifiez les informations fournies';
                toast.error(msg);
            }

            if (r?.status === 401) {
                localStorage.setItem('token', '');
                window.location.href = '/connexion';
            }

            if (r?.status >= 500) {
                const msg = 'Erreur serveur';
                toast.error(msg);
            }

            return Promise.reject(err);
        },
    );

    if (config.hasOwnProperty('displayErrorToast')) {
        alert('Axios erreur');
    }
}

export default axios;
